export const team = {
    'meta': {
        'title': 'Psycholodzy, psychiatrzy i psychoterapeuci #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Psychiatrzy, psycholodzy, psychoterapeuci przyjmujący w Centrum Psychiatrii i Psychoterapi COLLIGO #cityLocativeIn#.'
    },
    'url': {
        'address': '#cityIdUrl#/zespol/',
        'title': 'Psycholodzy, psychiatrzy i psychoterapeuci #cityLocativeIn# • Centrum COLLIGO',
        'name': 'Zespół'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dziecięcy #cityLocativeIn#. Psychiatra #cityLocativeIn#. Psychoterapia #cityLocativeIn#. Psychologia #cityLocativeIn#. Gabinety w dogodnym miejscu #cityLocativeIn#.'
        }
    }
}